import React from "react";

/**
 * 緑ボタンコンポーネント
 * @param {string} title ボタンタイトル
 * @param {Function} onClick ボタン押下時の処理
 * @param {string} className クラス名
 * @class CancelButton
 */

export default function CancelButton({
  title = "キャンセル",
  onClick,
  className = "",
}) {
  return (
    <button className={`btn btn-cancel ${className}`} onClick={onClick}>
      {title}
    </button>
  );
}
